import { render, staticRenderFns } from "./SharesCardSkeleton.vue?vue&type=template&id=9dccf822&scoped=true"
import script from "./SharesCardSkeleton.vue?vue&type=script&lang=js"
export * from "./SharesCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SharesCardSkeleton.vue?vue&type=style&index=0&id=9dccf822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dccf822",
  null
  
)

export default component.exports